export const AuthCypressAttribute = {
  forgotPassword: {
    buttons: {
      SEND_RESET_INSTRUCTIONS: 'AuthCypressAttribute:forgotPassword:buttons:SEND_RESET_INSTRUCTIONS'
    },
    inputs: {
      EMAIL: 'AuthCypressAttribute:forgotPassword:inputs:EMAIL'
    }
  },
  resetPassword: {
    buttons: {
      RESET_PASSWORD: 'AuthCypressAttribute:resetPassword:buttons:RESET_PASSWORD'
    },
    inputs: {
      PASSWORD: 'AuthCypressAttribute:resetPassword:inputs:PASSWORD',
      CONFIRM_PASSWORD: 'AuthCypressAttribute:resetPassword:inputs:CONFIRM_PASSWORD'
    }
  },
  buttons: {
    RESEND_INVITE: 'AuthCypressAttribute:buttons:RESEND_INVITE'
  },
  inputs: {},
  views: {},
  onboarding: {
    buttons: {
      GETTING_STARTED: 'AuthCypressAttribute:GETTING_STARTED'
    },
    inputs: {
      DATE_OF_DEATH: 'AuthCypressAttribute:DATE_OF_DEATH',
      RADIO_HAS_WILL: 'AuthCypressAttribute:RADIO_HAS_WILL',
      RADIO_HAS_LOCATED_WILL: 'AuthCypressAttribute:RADIO_HAS_LOCATED_WILL',
      RADIO_SOLE_OWNER_OF_REAL_ESTATE: 'AuthCypressAttribute:RADIO_SOLE_OWNER_OF_REAL_ESTATE',
      RADIO_OWN_ASSETS_ABOVE_25K: 'AuthCypressAttribute:RADIO_OWN_ASSETS_ABOVE_25K',
      RADIO_ESTATE_FORMS: 'AuthCypressAttribute:RADIO_ESTATE_FORMS',
      OVERVIEW_SELECT_STATE_OR_PROVINCE: 'AuthCypressAttribute:OVERVIEW_SELECT_STATE_OR_PROVINCE',
      DATE_TERMINATED: 'AuthCypressAttribute:DATE_TERMINATED',
      RADIO_SELECT_PROFESSION: 'AuthCypressAttribute:RADIO_SELECT_PROFESSION'
    },
    views: {
      ESTATE_FORM_LIST: 'AuthCypressAttribute:ESTATE_FORM_LIST'
    }
  },
  login: {
    buttons: {
      LOGIN: 'AuthCypressAttribute:LOGIN',
      HELP_ME_LOG_IN: 'AuthCypressAttribute:HELP_ME_LOG_IN',
      FORGOT_PASSWORD: 'AuthCypressAttribute:FORGOT_PASSWORD',
      HEADER_LOGIN: 'AuthCypressAttribute:HEADER_LOGIN',
      HEADER_SIGNUP: 'AuthCypressAttribute:HEADER_SIGNUP',
      BACK_TO_LOGIN: 'AuthCypressAttribute:BACK_TO_LOGIN',
      SSO_LOGIN: 'AuthCypressAttribute:SSO_LOGIN',
      LOGIN_WITH_EMAIL: 'AuthCypressAttribute:LOGIN_WITH_EMAIL'
    },
    inputs: {
      EMAIL: 'AuthCypressAttribute:EMAIL',
      PASSWORD: 'AuthCypressAttribute:PASSWORD',
      REMEMBER_ME: 'AuthCypressAttribute:REMEMBER_ME'
    },
    views: {
      FORM: 'AuthCypressAttribute:login:views:FORM',
      SOCIAL_SEPARATOR: 'AuthCypressAttribute:SOCIAL_SEPARATOR',
      ERROR_ICON: 'AuthCypressAttribute:ERROR_ICON',
      ERROR_MESSAGE: 'AuthCypressAttribute:ERROR_MESSAGE'
    }
  },
  signup: {
    buttons: {
      SIGNUP: 'AuthCypressAttribute:signup:buttons:SIGNUP',
      GOOGLE_SIGNUP: 'AuthCypressAttribute:signup:buttons:GOOGLE_SIGNUP',
      LANGUAGE_DROPDOWN_ITEM: 'AuthCypressAttribute:signup:buttons:LANGUAGE_DROPDOWN_ITEM',
      OPEN_LANGUAGE_DROPDOWN: 'AuthCypressAttribute:signup:buttons:OPEN_LANGUAGE_DROPDOWN',
      GO_TO_LOGIN: 'AuthCypressAttribute:signup:buttons:GO_TO_LOGIN',
      BACK_TO_SIGNUP: 'AuthCypressAttribute:signup:buttons:BACK_TO_SIGNUP',
      SSO: 'AuthCypressAttribute:signup:buttons:SSO'
    },
    inputs: {
      FIRST_NAME: 'AuthCypressAttribute:signup:inputs:FIRST_NAME',
      LAST_NAME: 'AuthCypressAttribute:signup:inputs:LAST_NAME',
      EMAIL: 'AuthCypressAttribute:signup:inputs:EMAIL',
      PASSWORD: 'AuthCypressAttribute:signup:inputs:PASSWORD',
      CONFIRM_PASSWORD: 'AuthCypressAttribute:signup:inputs:CONFIRM_PASSWORD'
    },
    views: {
      SIGNUP_FORM: 'AuthCypressAttribute:signup:views:SIGNUP_FORM',
      COMPANY_LOGO: 'AuthCypressAttribute:signup:views:COMPANY_LOGO'
    }
  },
  invited: {
    buttons: {
      PRIVACY_POLICY: 'AuthCypressAttribute:PRIVACY_POLICY',
      TERMS_OF_USE: 'AuthCypressAttribute:TERMS_OF_USE',
      REGISTER: 'AuthCypressAttribute:invited:buttons:REGISTER'
    },
    inputs: {
      EMAIL: 'AuthCypressAttribute:invited:inputs:EMAIL',
      PASSWORD: 'AuthCypressAttribute:invited:inputs:PASSWORD'
    },
    views: {}
  },
  profile: {
    inputs: {
      DARK_MODE: 'AuthCypressAttribute:profile:DARK_MODE',
      FIRST_NAME: 'AuthCypressAttribute:profile:FIRST_NAME',
      BIO_EN: 'AuthCypressAttribute:profile:BIO_EN',
      BIO_FR: 'AuthCypressAttribute:profile:BIO_FR',
      PLANNING_HUBSPOT_MEETING_LINKS: 'AuthCypressAttribute:profile:PLANNING_HUBSPOT_MEETING_LINKS',
      PLANNING_HUBSPOT_MEETING_LINKS_FRENCH:
        'AuthCypressAttribute:profile:PLANNING_HUBSPOT_MEETING_LINKS_FRENCH',
      SETTLEMENT_HUBSPOT_MEETING_LINKS:
        'AuthCypressAttribute:profile:SETTLEMENT_HUBSPOT_MEETING_LINKS',
      SETTLEMENT_HUBSPOT_MEETING_LINKS_FRENCH:
        'AuthCypressAttribute:profile:SETTLEMENT_HUBSPOT_MEETING_LINKS_FRENCH',
      INTAKE_FR: 'AuthCypressAttribute:profile:INTAKE_FR',
      GUIDANCE_FR: 'AuthCypressAttribute:profile:GUIDANCE_FR',
      WILL_REVIEW_FR: 'AuthCypressAttribute:profile:WILL_REVIEW_FR',
      INTAKE_EN: 'AuthCypressAttribute:profile:INTAKE_EN',
      GUIDANCE_EN: 'AuthCypressAttribute:profile:GUIDANCE_EN',
      WILL_REVIEW_EN: 'AuthCypressAttribute:profile:WILL_REVIEW_EN',
      ANNUAL_REVIEW_EN: 'AuthCypressAttribute:profile:ANNUAL_REVIEW_EN',
      ANNUAL_REVIEW_FR: 'AuthCypressAttribute:profile:ANNUAL_REVIEW_FR'
    }
  },
  deleteAccount: {
    buttons: {
      DELETE_MY_ACCOUNT: 'AuthCypressAttribute:deleteAccount:buttons:DELETE_MY_ACCOUNT'
    }
  },
  deprecatedPage: {
    buttons: {
      VIEW_PLANNING_OPTIONS: 'AuthCypressAttribute:deprecatedPage:buttons:VIEW_PLANNING_OPTIONS'
    }
  }
};
